document.addEventListener('DOMContentLoaded', function () {
    const metaTag = document.querySelector('meta[name="theme-color"]');

    const updateThemeColor = () => {
        const root = getComputedStyle(document.documentElement);
        const themeColor = root.getPropertyValue('--color-primary').trim();
        const bgColor = root.getPropertyValue('--color-background').trim();

        if (metaTag && themeColor) metaTag.content = themeColor;
        if (bgColor) document.documentElement.style.backgroundColor = bgColor;
    };

    updateThemeColor();
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', updateThemeColor);
});
